export default __webpack_public_path__ + "static/media/blush-bright-spring.22487588.png";